export default __webpack_public_path__ + "static/media/imageTyping.3912569e.jpg";